import { ApiResponse, DataObject, DataPaginate } from "@/types";
import { fetcher, sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { useQuery } from "@tanstack/react-query";
import { ToolsFormPayload } from "./validation";

// get
const getTools = async (
  query?: string
): Promise<ApiResponse<DataPaginate<ToolsResponse>>> => {
  return await fetcher(query ? `master/akd?${query}` : `master/akd`);
};

export const useGetTools = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<ToolsResponse>>, Error>(
    ["useGetTools", query],
    () => getTools(query),
    {
      keepPreviousData: true,
      refetchIntervalInBackground: true,
    }
  );
};

// get by id
export const getToolId = async (
  id: number
): Promise<ApiResponse<DataObject<ToolsResponse>>> => {
  return await fetcher(`master/akd/${id}`);
};

export const useGetToolId = (id: number) => {
  return useQuery<ApiResponse<DataObject<ToolsResponse>>, Error>(
    ["useGetToolId", id],
    () => getToolId(id)
  );
};

// post
export const useTools = (method: "POST" | "PUT" = "POST", id?: number) => {
  return useFormMutation<
    ApiResponse<DataObject<ToolsFormPayload>>,
    Error,
    ToolsFormPayload
  >({
    mutationFn: async (
      data
    ): Promise<ApiResponse<DataObject<ToolsFormPayload>>> => {
      const endpoint = id ? `master/akd/${id}` : "master/akd";
      const delay = new Promise((resolve) => setTimeout(resolve, 2000));
      const response: ApiResponse<DataObject<ToolsFormPayload>> =
        await sendData(endpoint, data, method);
      await delay;
      return response;
    },
    loadingMessage:
      method === "POST" ? "Menyimpan data..." : "Memperbarui data...",
    successMessage:
      method === "POST"
        ? "Data berhasil ditambahkan"
        : "Data berhasil diperbarui",
  });
};
